import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTypography = styled(Typography)(({ variant, color }) => {
  const styles = {
    pageHeader: {
      fontWeight: 900,
      fontSize: "30px",
      lineHeight: "100%",
      display: "block",
    },
    paragraph: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
    },
    paragraph2: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "100%",
    },
    paragraph3: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "24px",
    },
    subtitle2: {
      fontWeight: 700,
      fontSize: "14px",
      lineHeight: "20px",
    },
    subtitle3: {
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "100%",
    },
  };

  return {
    ...styles[variant],
    color: color || "black",
  };
});

const Text = ({ variant = "paragraph", color, children, ...props }) => {
  return (
    <StyledTypography variant={variant} color={color} {...props}>
      {children}
    </StyledTypography>
  );
};

export default Text;
